









import {Vue, Component} from 'vue-property-decorator';
import TheButton from '@/components/buttons/TheButton.vue';
import ChatbotSorryImage from '@/components/images/ChatbotSorryImage.vue';

@Component({
  components: {
    TheButton,
    ChatbotSorryImage,
  },
})
export default class Maintenance extends Vue {
}
